<div [formGroup]="parentForm" class="grid">
    <mat-tab-group id="tab-group">
        @for (type of objectTypes$ | async; track type.name) {
            <mat-tab label="{{ type.label }}">
                <br>
                @if (type.name && getObjectTypeGroup(type.name, true); as typeGroup) {
                    <pixl-global-metadata-select
                            [parentForm]="typeGroup"
                            [consumerMetadataIds]="getSelectedMetadataIds(typeGroup)"
                            targetArrayName="metadata"
                            class="full-width">
                    </pixl-global-metadata-select>
                }
            </mat-tab>
        }
    </mat-tab-group>
</div>